// JavaScript Document
// Desc: Auto tabs to next form element after len and adds a '-' to input after len2.

const isNN = (navigator.appName.indexOf("Netscape") !== -1);

export function autoTabWithDash(input: any, len: number, len2: number, e: any): void {
    const keyCode = (isNN) ? e.which : e.keyCode;
    const filter = (isNN) ? [0, 8, 9] : [0, 8, 9, 16, 17, 18, 37, 38, 39, 40, 46];

    if (input.value.length === (len2) && !filter.includes(keyCode)) {
        input.value = input.value.slice(0, len2) + "-" + input.value.slice(len2 + 1, 1);
    }
    if (input.value.length >= len && !filter.includes(keyCode)) {
        input.form[(getIndex(input) + 1) % input.form.length].focus();
    }

}
export function autoTabWithDash2(input: any, len: number, len2: number, len3: number, e: any):void {
    const keyCode = (isNN) ? e.which : e.keyCode;
    const filter = (isNN) ? [0, 8, 9] : [0, 8, 9, 16, 17, 18, 37, 38, 39, 40, 46];

    if (input.value.length === (len2) && !filter.includes(keyCode)) {
        input.value = input.value.slice(0, len2) + "-" + input.value.slice(len2 + 1, 1);
    }
    if (input.value.length === (len3) && !filter.includes(keyCode)) {
        input.value = input.value.slice(0, len3) + "-" + input.value.slice(len3 + 1, 1);
    }
    if (input.value.length >= len && !filter.includes(keyCode)) {
        input.form[(getIndex(input) + 1) % input.form.length].focus();
    }
}

function getIndex(input: any): number {
    let index = -1, i = 0;
    while (i < input.form.length && index === -1) {
        if (input.form[i] === input) {
            index = i;
        }
        else {
            i++;
        }
    }

    return index;
} 